/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Type of the device attribute
 */
export type UpdateDeviceAttributeDtoType = (typeof UpdateDeviceAttributeDtoType)[keyof typeof UpdateDeviceAttributeDtoType];

export const UpdateDeviceAttributeDtoType = {
  PROPERTY: 'property',
  REALTIME: 'realTime',
} as const;
